// Per-country legal entity used to fill the {{entityName}} / {{entityAddress}}
// placeholders in the shared EMEA Patient Privacy Policy and Terms of Use.
// The EMEA documents are identical text apart from these named entities.
export interface EmeaEntity {
  entityName: string;
  entityAddress: string;
}

// Keyed by the entity's own labels. Note the UK entity is keyed "UK" while the
// app detects the country as ISO "GB" — see getEmeaEntity for the mapping.
const EMEA_ENTITIES: Record<string, EmeaEntity> = {
  IE: {
    entityName: "Johnson & Johnson (Ireland) Limited",
    entityAddress: "Airton Road, Tallaght, Dublin 24, Ireland",
  },
  UK: {
    entityName: "Johnson & Johnson Medical Limited",
    entityAddress:
      "Baird House, 4 Lower Gilmore Bank, Edinburgh, Scotland, EH3 9QP",
  },
  AT: {
    entityName: "Johnson & Johnson Medical Products GmbH",
    entityAddress: "Vorgartenstrasse 206B, 1020 Wien, Österreich",
  },
  CH: {
    entityName: "Johnson & Johnson AG",
    entityAddress: "Gubelstrasse 34, 6300 Zug, Switzerland",
  },
  DE: {
    entityName: "Johnson & Johnson Medical GmbH",
    entityAddress: "Robert-Koch-Straße 1, 22851 Norderstedt, Deutschland",
  },
};

// Detected ISO country code → entity. The UK is detected as "GB".
export const getEmeaEntity = (countryCode: string): EmeaEntity | null => {
  const key = countryCode === "GB" ? "UK" : countryCode;
  return EMEA_ENTITIES[key] ?? null;
};
